import type { FC } from 'react';
import classnames from 'classnames';

import style from './style.scss';

interface Props {
  tier: Tier;
  className?: string;
}

const tierClassNames: { [key in Tier]: string } = {
  s: style.tier_s,
  a: style.tier_a,
  b: style.tier_b,
  c: style.tier_c,
  d: style.tier_d,
  unranked: ''
};

const TierIndicator: FC<Props> = ({ tier, className }) => (
  <span className={classnames(style.tier, tierClassNames[tier], className)}>
    <span className={style.tierLetter}>{tier !== 'unranked' && tier.toUpperCase()}</span>
  </span>
);

TierIndicator.displayName = 'TierIndicator';

export default TierIndicator;
